import { render, staticRenderFns } from "./VASPostingSettings.vue?vue&type=template&id=b6823420&scoped=true"
import script from "./VASPostingSettings.vue?vue&type=script&lang=js"
export * from "./VASPostingSettings.vue?vue&type=script&lang=js"
import style0 from "./VASPostingSettings.vue?vue&type=style&index=0&id=b6823420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6823420",
  null
  
)

export default component.exports